<template>

    <!-- sidebar -->
    <div class="sidebar-settings">
        <div class="sidebar-settings-scrollarea">
            <component :is="settingsFromWeebly.name+'Settings'"></component>
        </div>
    </div>

</template>

<script>
import ButtonSettings from '../elements/elementSettings/ButtonSettings'
import BlocksSettings from '../elements/elementSettings/BlocksSettings'
import VerticalDividerSettings from '../elements/elementSettings/VerticalDividerSettings'
import HorizontalDividerSettings from '../elements/elementSettings/HorizontalDividerSettings'
import LightBoxSettings from '../elements/elementSettings/LightBoxSettings'
import AccordionSettings from '../elements/elementSettings/AccordionSettings'
import AnchorSettings from '../elements/elementSettings/AnchorSettings'
import ContentSliderSettings from '../elements/elementSettings/ContentSliderSettings'
import ImageSliderSettings from '../elements/elementSettings/ImageSliderSettings'
import TestimonialSliderSettings from '../elements/elementSettings/TestimonialSliderSettings'
import ContentSliderCarouselSettings from '../elements/elementSettings/ContentSliderCarouselSettings'
import AnimateOnScrollSettings from '../elements/elementSettings/AnimateOnScrollSettings'
import BlogcardsSettings from '../elements/elementSettings/BlogcardsSettings'
import BlogcardsSliderSettings from '../elements/elementSettings/BlogcardsSliderSettings'
import PricingtablesSettings from '../elements/elementSettings/PricingtablesSettings'
import TitleSettings from '../elements/elementSettings/TitleSettings'


export default {
    name: 'SidebarSettings',
    components: {
        ButtonSettings,
        BlocksSettings,
        HorizontalDividerSettings,
        VerticalDividerSettings,
        LightBoxSettings,
        AccordionSettings,
        AnchorSettings,
        ContentSliderSettings,
        AnimateOnScrollSettings,
        ContentSliderCarouselSettings,
        ImageSliderSettings,
        TestimonialSliderSettings,
        BlogcardsSettings,
        BlogcardsSliderSettings,
        PricingtablesSettings,
        TitleSettings
    },
    data() {
        return{
            mainSidebarShown: false
        }
    },
    methods: {
        showMainSidebar(el) {

            this.mainSidebarShown = !this.mainSidebarShown

            this.mainSidebarShown 
            ? document.body.classList.add('right-pull')
            : document.body.classList.remove('right-pull')

        }
    },
    computed:{
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        }
    },
    mounted() {

        // make sidebar menu icon appear
        this.$store.state.showSettingsBar = true

    }
}
</script>

<style lang="less">
@import '../../less/colors.less';
.input-with-right-setting-icon {
    padding-right: 45px;
}

span.input-right-setting-icon {
    position: absolute;
    top: 27px;
    right: 1px;
    font-size: 11px;
    cursor: pointer;
    height: 27px;
    line-height: 27px;
    background: @light_blue;
    width: 30px;
    text-align: center;
    border-radius: 0 0.25rem 0.25rem 0;
    border-left: 1px solid @border_grey_dark;
}
.sidebar-settings {
    background: @white;
    border-right: 1px solid @border_grey_medium;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 250px;
    padding: 75px 0px 0px;
    z-index: 11;
    transition: left .3s ease-out;
    overflow: hidden;

    .settings-divider {
        width: calc(~"100% + 30px");
        margin-left: -15px;
        background: @border_grey_dark;
    }

    .settings-group-title h6 {
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: .05em;
        color: @title_grey;
        line-height: 1;
        padding: 15px 0;
        text-align: center;
        font-weight: 700;
        position: relative;
        margin-bottom: 20px;
        background: @border_grey_medium;
        width: calc(~"100% + 30px");
        margin-left: -15px;

        &:before, &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            // width: calc(~"100% + 30px");
            width: 100%;
            height: 1px;
            background: @border_grey_medium;
        }
         &:after {
             bottom: 0;
             top: auto;
         }
    }

    .settings-group-description {

        p {
            font-size: 13px;
            border-bottom: 1px solid @border_grey_medium;
            padding-bottom: 15px;
            margin-bottom: 30px;
        }

    }

    .setting {
        margin-bottom: 30px;
    }
}

.sidebar-settings-scrollarea {
    overflow-y: auto;
    padding: 25px 15px 30px;
    height: 100%;
}

.right-pull .sidebar-settings {
    left: 75px;
}

.show-sidebar-btn {
    position: absolute;
    top: 100px;
    left: 15px;
    
    i {
        cursor: pointer;
        color: @subtitle_grey;
        transition: transform .3s ease-out;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;

        &:hover {
            color: @action_blue;
        }
    }
}

.right-pull .sidebar-settings {
    .show-sidebar-btn i {
        transform: rotate(-180deg);
    }
}

.right-pull .global-container {
    padding-left: 340px;
}

.grouped-devices-settings {
    position: relative;
}

.device-selector--mini {
    text-align: center;
    padding: 15px 0;
    // border-top: 1px solid @border_grey_medium;
    // border-bottom: 1px solid @border_grey_medium;
    width: 100%;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;

    i {
        width: 65px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        border-radius: .25rem;
        cursor: pointer;
        background: @shark_teeth;
        font-size: 12px;
        border: 1px solid @border_grey_dark;

        &:hover, &.active {
            border-color: @action_blue;
            background: @action_blue;
            color: #fff;
        }
    }
}

.border-group {
    padding: 25px 5px 15px;
    border: 1px solid @border_grey_medium;
    background: @light_blue;
    position: relative;
    margin-bottom: 30px;
    margin-top: 30px;

    .border-group--title {
        position: absolute;
        height: 24px;
        padding: 0 7px;
        line-height: 24px;
        font-size: 12px;
        background: #fff;
        top: -12px;
        border-radius: .25rem;
        border: 1px solid @border_grey_dark;
        font-weight: 700;
        left: 5px;
    }

    .unlink-border-radius {
        top: -12px;
        right: 5px;
        border: 1px solid @border_grey_dark;
        position: absolute;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        margin-left: 5px;
        border-radius: 20px;
        cursor: pointer;
        background: @light_blue;
        font-size: 10px;
    }

    .setting {
        padding: 0;
        border: 0;
        background: none;
    }
}

.settings-box-child {
    position: absolute;
    width: 350px;
    background: #fff;
    border: 1px solid #bec7d5;
    z-index: 100;
    border-radius: 0.25rem;
    margin-bottom: 30px;
    -webkit-box-shadow: 0 3px 17px rgba(51, 61, 71, 0.2);
    box-shadow: 0 3px 17px rgba(51, 61, 71, 0.2);
}
.settings-box-child:after, .settings-box-child:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.settings-box-child .settings-box-child-title h6 {
    border-bottom: 1px solid #D8DDE5;
    padding: 0 15px;
    line-height: 50px;
    margin: 0;
    background: #fff;
    border-radius: 0.25rem 0.25rem 0 0;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    text-transform: capitalize;
    cursor: move;
    cursor: -webkit-grab;
    cursor: grab;
}
.settings-box-child .settings-box-child-inner {
    overflow-y: auto;
    height: 350px;
    padding: 15px;
    font-size: 12px;
    width: 350px;
    background: #fafbfd;
}
.settings-box-child:after {
    border-color: rgba(242, 243, 245, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: -8px;
}

.setting-section .setting-section-title h6 {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 400;
    padding-left: 7px;
}

.setting-section .setting-section-content .setting .custom-control-label {
    font-weight: 400;
}

.setting-section .setting-section-content {
    padding: 15px 7px 0;
    background: #fff;
    border: 1px solid #D8DDE5;
}

.setting-section .setting-section-content .setting {
    border: 0;
    margin-bottom: 15px;
    background: none;
}

.setting-section .setting-section-content .setting {
    border: 0;
    margin-bottom: 15px;
    background: none;
}



</style>




// WEBPACK FOOTER //
// src/components/layout/SidebarSettings.vue